import PropTypes from 'prop-types';
import {Popover as AntPopover} from 'antd';
import classNames from 'classnames';
import styles from './index.less';

const ETUIPopover = ({fullSizeContent, overlayClassName, ...props}) => {
    const className = classNames(overlayClassName, {[styles.fullSize]: fullSizeContent});

    return <AntPopover overlayClassName={className} {...props} />;
};

Object.assign(ETUIPopover, AntPopover);

ETUIPopover.propTypes = {
    ...ETUIPopover.propTypes, // eslint-disable-line react/forbid-foreign-prop-types
    fullSizeContent: PropTypes.bool
};

ETUIPopover.defaultProps = {
    fullSizeContent: false
};

export default ETUIPopover;

